import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  page: {
    sections: []
  },
  sections: [],
  loading: false,
  error: null
}

const paidConsumerHomepageSlice = createSlice({
  name: 'paidConsumerHomepage',
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.page = payload
      state.loading = false
    },
    setLoading: (state, { payload }) => {
      state.loading = true
    },
    setError: (state, { payload }) => {
      state.error = payload
      state.loading = false
    }
  }
})

export const { setPage, setLoading, setError } = paidConsumerHomepageSlice.actions

export const { reducer } = paidConsumerHomepageSlice
